import { render } from "./CoachRegistration.vue?vue&type=template&id=5b8342fe&scoped=true"
import script from "./CoachRegistration.vue?vue&type=script&lang=js"
export * from "./CoachRegistration.vue?vue&type=script&lang=js"

import "./CoachRegistration.vue?vue&type=style&index=0&id=5b8342fe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5b8342fe"

export default script